import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ClrInputModule, ClrSelectModule } from "@clr/angular";
import { TranslocoDirective } from "@jsverse/transloco";

import { environment as env } from "../../../../environments/environment";

import { CountrySelectComponent } from '../../../_shared/components/country-select/country-select.component';
@Component({
  selector: 'app-person-form',
  standalone: true,
  imports: [
    CountrySelectComponent,CommonModule, ReactiveFormsModule, ClrInputModule, ClrSelectModule, TranslocoDirective],
  templateUrl: './person-form.component.html',
  styleUrls: ['./person-form.component.sass']
})
export class PersonFormComponent {
  @Input() personForm!: FormGroup;
  devMode: boolean;
  crmMode: boolean;

  constructor() {
    this.devMode = env.stages.dev;
    this.crmMode = env.externalCrm;
  }
}
